import Dialog from "apollo-react/components/Dialog";
import DialogActions from "apollo-react/components/DialogActions";
import DialogTitle from "apollo-react/components/DialogTitle";
import DialogContent from "apollo-react/components/DialogContent";
import DialogContentText from "apollo-react/components/DialogContentText";
import Button from 'apollo-react/components/Button';
import { useTranslation } from 'react-i18next';
import './ChangeNameDialog.scss';

export default function ChangeNameDialog({
    isOpen,
    title,
    content,
    buttonConfirmTitle,
    buttonCancelTitle,
    onOk,
    onCancel,
}) {

    const [t] = useTranslation();

    return (
        <Dialog className="changeDialog" open={isOpen} fullWidth={true} maxWidth='100rem'>
            <DialogTitle className='title'>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText style={{ whiteSpace: 'pre-line' }}>
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="confirmBtn" onClick={onOk} variant="primary">
                    {buttonConfirmTitle}
                </Button>
                <Button className="cancelBtn" onClick={onCancel} variant="outlined">
                    {buttonCancelTitle}
                </Button>
            </DialogActions>
        </Dialog>
    );
}